import React from 'react'
import { Form } from 'semantic-ui-react'

export default class ImageVisibilityField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const visibilityOptions = [
      { key: 1, text: 'Hide', value: true },
      { key: 2, text: 'Show', value: false },
    ]

    return (
      <Form.Select
        required
        fluid
        label="Store Item Image Visibility"
        options={visibilityOptions}
        placeholder="Show/Hide"
        onChange={(e, data) => onChange('hide_item_image', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/imageVisibilityField.js